<template>
  <el-pagination :page-size="pageSize" :page-sizes="pageSizes" :total="total" @current-change="handleCurrentChange"
    @size-change="handleSizeChange" layout="total, sizes, prev, pager, next, jumper">
  </el-pagination>
</template>

<script>
import { reactive, toRefs } from "vue";
import { useStore } from "vuex";
import { pageSize } from "@/common/js/config.default.js"
export default {
  props: {
    //每页显示条目个数
    pageSize: {
      type: Number,
      default: () => useStore().state.pageSize,
    },
    // 每页显示个数选择器的选项设置
    pageSizes: {
      type: Array,
      default: () => [6, 8, 10, 12, 20],
    },
    //总条目数
    total: {
      type: Number,
      default: () => 100,
    },
  },

  setup(props, { emit }) {
    let data = reactive({
      pageSizeInfo: {
        pageNum: 1, //当前点击的页码数
        pageSize,
      },
    });

    //currentPage 改变时会触发
    let handleCurrentChange = (e) => {
      //   console.log('handleCurrentChange: ', e);
      data.pageSizeInfo.pageNum = e;
      emit("handleCurrentChange", data.pageSizeInfo);
    };

    //pageSize 改变时会触发
    let handleSizeChange = (e) => {
      //   console.log('handleSizeChange: ', e);
      data.pageSizeInfo.pageSize = e;
      emit("handleCurrentChange", data.pageSizeInfo);
    };

    return {
      handleCurrentChange,
      handleSizeChange,
      ...toRefs(data),
    };
  },
};
</script>

<style scoped>
</style>
